module.exports = __webpack_public_path__ + "img/bevip.2a133ed3.png";